import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import loadImage from "blueimp-load-image";
import Grid from "@material-ui/core/Grid";
import ReactSelect from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import { IframeTypes } from "../../Constants/selections";

import iframePageDefaultImg from "../../assets/media/iframe-page-default.png";
import remove_icon from "../../assets/media/stop.png";
import "./index.css";

const BespokeIFrame = (props) => {
  const location = useLocation();
  const history = useHistory();
  const fileUploader = useRef();
  const [loading, setLoading] = useState(true);
  const [brandID, setBrandID] = useState();
  const [brandData, setBrandData] = useState({});
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState();
  const [isPageTypeEditing, setIsPageTypeEditing] = useState(-1);
  const [isPageNameEditing, setIsPageNameEditing] = useState(-1);
  const [isPageLinkEditing, setIsPageLinkEditing] = useState(-1);
  const [iframes, setIframes] = useState([]);

  useEffect(() => {
    console.log("location", location);
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setLoading(true);
      setBrandID(brand);
      setUserName(username);
      setUserRole(role);
      Firebase.getBrandDataByID(brand, (res) => {
        setBrandData(res);
        if (res.iframes) {
          console.log("iframes", res.iframes);
          setIframes(res.iframes);
        }
        setLoading(false);
      });
    }
  }, []);

  const selectedFile = async (e, index) => {
    if (!brandID || !brandData) {
      return;
    }

    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          async function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            // _this.setState({ content: img_src });
            let icon_url = await Firebase.addIFrameIcon(
              `${brandData.name}${Date.now()}`,
              img_src
            );
            await Firebase.updateBrandIframesById(brandID, index, {
              icon: icon_url,
            });

            // let img_content = "data:image/jpeg;base64," + img_src;
            // setPageIcon(img_content);
          },
          {
            canvas: true,
            meta: true,
          }
        );
      });
    }
  };

  const handleChange = (key, value, index) => {
    const new_iframes = [...iframes];
    new_iframes[index][key] = value;
    console.log("----", new_iframes);
    setIframes(new_iframes);
  };

  const handleSave = async (index) => {
    setIsPageTypeEditing(-1);
    setIsPageNameEditing(-1);
    setIsPageLinkEditing(-1);
    if (!brandID || !brandData) {
      return;
    }
    await Firebase.updateBrandIframesById(brandID, index, {
      ...iframes[index],
    });
  };

  const addNewIframe = () => {
    if (!brandID || !brandData) {
      return;
    }
    const new_iframes = [
      ...iframes,
      { name: "", link: "", type: IframeTypes[0].value },
    ];
    Firebase.updateBrandDataById(brandID, {
      iframes: new_iframes,
    });
  };

  const deleteIframe = (iframe, index) => {
    const new_iframes = [...iframes];
    new_iframes.splice(index, 1);
    Firebase.updateBrandDataById(brandID, {
      iframes: new_iframes,
    });
  };

  return (
    <div
      id="page-container"
      // style={{
      //   backgroundColor: !loading && brandData.dark ? "black" : "unset",
      // }}
    >
      <Header
        username={userName}
        role={userRole}
        onHome={this.goBack}
        logo={brandData.logo}
        brand={brandID}
        brandName={brandData.name}
        is_property_brand={!!brandData.is_property_brand}
      />
      {loading ? (
        <div className="loading">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      ) : (
        <div className="bespoke-iframe-container">
          <div className="iframe-table-header">
            <Grid container spacing={3}>
              <Grid item xs={2}>
                <p className="container-label">iFrame type</p>
              </Grid>
              <Grid item xs={3}>
                <p className="container-label">iFrame Page Name</p>
              </Grid>
              <Grid item xs={2}>
                <p className="container-label">Page Icon</p>
              </Grid>
              <Grid item xs={4}>
                <p className="container-label">Page Link</p>
              </Grid>
            </Grid>
          </div>
          <div className="iframe-table-content">
            {iframes.map((iframe, index) => (
              <Grid container spacing={3} key={`iframe-${index}`}>
                <Grid item xs={2} className="flex-row align-center">
                  {isPageTypeEditing === index ? (
                    <div className="flex-row align-center full-width">
                      <div className="full-width">
                        <ReactSelect
                          value={
                            iframe.type
                              ? IframeTypes.find((t) => t.value === iframe.type)
                              : IframeTypes[0]
                          }
                          onChange={(e) => {
                            handleChange("type", e.value, index);
                          }}
                          options={IframeTypes}
                        />
                      </div>
                      <i
                        className="si si-check ml-2"
                        onClick={() => handleSave(index)}
                      />
                    </div>
                  ) : (
                    <div className="flex-row align-center full-width">
                      <p style={{ margin: 0 }}>
                        {iframe.type
                          ? IframeTypes.find((t) => t.value === iframe.type)
                              .label
                          : IframeTypes[0].label}
                      </p>
                      <i
                        className="si si-settings ml-2"
                        onClick={() => setIsPageTypeEditing(index)}
                      />
                    </div>
                  )}
                </Grid>
                <Grid item xs={3} className="flex-row align-center">
                  <div className="flex-row align-center full-width">
                    <input
                      type="text"
                      name="name"
                      onChange={(e) => {
                        handleChange("name", e.target.value, index);
                      }}
                      value={iframe.name}
                      disabled={isPageNameEditing !== index}
                    />
                    {isPageNameEditing === index ? (
                      <i
                        className="si si-check ml-2"
                        onClick={() => handleSave(index)}
                      />
                    ) : (
                      <i
                        className="si si-settings ml-2"
                        onClick={() => setIsPageNameEditing(index)}
                      />
                    )}
                  </div>
                </Grid>
                <Grid item xs={2} className="flex-row align-center">
                  <div className="flex-row align-center">
                    <img
                      alt=""
                      src={iframe.icon || iframePageDefaultImg}
                      className="page-image"
                    />
                    <button
                      className="edit-btn"
                      onClick={() => {
                        fileUploader.current.click();
                      }}
                    >
                      Edit
                    </button>
                  </div>
                </Grid>
                <Grid item xs={4} className="flex-row align-center">
                  <div className="flex-row align-center full-width">
                    <input
                      type="text"
                      name="link"
                      onChange={(e) => {
                        handleChange("link", e.target.value, index);
                      }}
                      value={iframe.link}
                      disabled={isPageLinkEditing !== index}
                    />
                    {isPageLinkEditing === index ? (
                      <i
                        className="si si-check ml-2"
                        onClick={() => handleSave(index)}
                      />
                    ) : (
                      <i
                        className="si si-settings ml-2"
                        onClick={() => setIsPageLinkEditing(index)}
                      />
                    )}
                  </div>
                </Grid>
                <Grid item xs={1} className="flex-row align-center">
                  <img
                    src={remove_icon}
                    className="remove-icon"
                    alt="remove"
                    onClick={(e) => deleteIframe(iframe, index)}
                  />
                </Grid>
                <input
                  type="file"
                  id="example-file-input"
                  ref={fileUploader}
                  name="example-file-input"
                  hidden
                  accept="image/*"
                  onChange={(e) => selectedFile(e, index)}
                />
              </Grid>
            ))}
            <button
              className="btn btn-brand-hex btn-white"
              style={{
                "--hover-color": brandData.hex ? brandData.hex : "white",
                "--hover-text-color": brandData.white ? "white" : "black",
                backgroundColor: "white",
                color: "black",
                marginTop: "20px",
              }}
              onClick={addNewIframe}
            >
              Create an iframe page
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BespokeIFrame;



// WEBPACK FOOTER //
// ./src/screens/BespokeIFrame/index.js